import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(
  ) { }
  getFullName(userName, firstName, lastName) {
    // if (firstName != '' && lastName != '') { firstName + ' ' + lastName }
    // else { userName };(firstName ? (lastName ?
    return (firstName && lastName) ? firstName + ' ' + lastName : userName;
  }

}
